import React, { useEffect } from "react";
import UserformService from "../services/userform.service";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreaters } from "../Redux";

export default function VerifyUser() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const userActions = bindActionCreators(actionCreaters, dispatch);
  const { id } = useParams();
  const loginBrpwse = async () => {
    try {
      const response = await UserformService.getOktaLoginUserInfo(id);

      await userActions.logIn(
        {
          registerUser: response?.data?.data || null,
        },
        "registerUserLogin"
      );

      window.location.href = "/register/registration-form-new";
    } catch (err) {
      window.location.href = "/";

      if (
        err?.response?.data?.message &&
        typeof err?.response?.data?.message === "string"
      ) {
        toast.error(err?.response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.error("Something went wrong, try again", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };
  useEffect(() => {
    if (id) {
      loginBrpwse();
    }
  }, [id]);
  return (
    <div className="fix-white" style={{ display: "block" }}>
      <div className={`loader in`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
